import request from '@/utils/server'
 
//  组织列表
export function getOutboundPlans(query) {
    return request({
      url: '/inventory/getOutboundPlans',
      method: 'get',
      params: query
    })
  }
